module.exports = __webpack_public_path__ + "img/full1-min.89fb7b91.png";